import { render, staticRenderFns } from "./form.vue?vue&type=template&id=47f7d885&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7d885",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f7d885')) {
      api.createRecord('47f7d885', component.options)
    } else {
      api.reload('47f7d885', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=47f7d885&scoped=true", function () {
      api.rerender('47f7d885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/splitting/form.vue"
export default component.exports